import React, { useState } from "react";
import { Button, Input } from "antd";
import { useMatch, useNavigate } from "react-router-dom";

import { GET_PERMISSIONS } from "graphql/query/permission-gql";

import Permission from "components/permission";
import Icons from "components/icons";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import { PageWrapDefault, Tables } from "components/layout";
import Localize, { localizeByKey } from "components/service/localize";
import { useMe } from "components/use-hooks";

import "./permission.scss";

const { Search } = Input;

const basePath = Permission.Const.basePath;
const tableHelper = Permission.Helpers.TableMain;

const PermissionsPage: React.FC = () =>
{
    useActiveMenuItem([ "variable-lists" ], [ "variable-lists" ]);

    const breadcrumbs = [
        {
            label: localizeByKey("BREADCRUMBS.Label_Permissions"),
            path: `${basePath}`,
        },
    ];

    useBreadCrumbs(breadcrumbs);

    const { me } = useMe();

    const isDeveloper = me?.roles?.some((role: any) => role.slug === 'role_developer');

    const pageNavbar = [
        {
            label: localizeByKey("NAVBAR_PAGES.Label_VariableLists"),
            path: "variable-lists",
        },
        {
            label: localizeByKey("NAVBAR_PAGES.Label_GraphicRules"),
            path: "graphic-rules",
        },
        ...(isDeveloper ? [{
            label: localizeByKey("NAVBAR_PAGES.Label_Permissions"),
            path: "permissions",
        }] : []),
    ];

    const navigate = useNavigate();

    const match = useMatch(`${basePath}/page/:pageNum`);

    const [ searchText, setSearchText ] = useState<string>("");

    return (
        <PageWrapDefault
            className="page-permissions"
            dataExist={true}
            title={<Localize>PAGES.Title_Settings</Localize>}
            pageNavbar={pageNavbar}
            staticPath=""
        >
            <Tables.Main
                model="permissions"
                query={GET_PERMISSIONS}
                varSet={{ perPage: 30 }}
                routeUrl={`${basePath}`}
                currentPage={match ? parseInt(match.params.pageNum || "1") : 1}
                searchText={searchText}
                tableHelper={tableHelper}
            >
                <div className="table-action-bar">
                    <div className="col">
                        <Search
                            className="filter-search"
                            prefix={<Icons.Search />}
                            onChange={(e) => setSearchText(e.target.value)}
                        />

                        <Button disabled icon={<Icons.Filter />}>
                            <span className="ellipsis">
                                <Localize>FORMS.Button_Text_Filters</Localize>
                            </span>
                        </Button>
                    </div>

                    <div className="col">
                        <Button
                            type="primary"
                            icon={<Icons.Plus />}
                            onClick={() => navigate(`${basePath}/create`)}
                        >
                            <span className="ellipsis">
                                <Localize>
                                    GLOBAL.Button_Text_CreateNew
                                </Localize>
                            </span>
                        </Button>
                    </div>
                </div>
            </Tables.Main>
        </PageWrapDefault>
    );
};

export default PermissionsPage;